function u(e, t) {
  if (e == null)
    return null;
  function i(o) {
    return o == null || t == null ? !1 : l(t) ? Element.prototype.matches.call(o, t) : r(t) ? [...t].includes(o) : s(t) ? t === o : f(t) ? t(o) : !1;
  }
  let n = e;
  do {
    if (n = n.correspondingUseElement || n.correspondingElement || n, i(n))
      return n;
    n = (n == null ? void 0 : n.parentNode) || null;
  } while (n != null && n !== document.body && n !== document);
  return null;
}
function l(e) {
  return typeof e == "string";
}
function r(e) {
  return e instanceof NodeList || e instanceof Array;
}
function s(e) {
  return e instanceof Node;
}
function f(e) {
  return typeof e == "function";
}
export {
  u as default
};
